import React, { useCallback, useEffect, useState } from "react";
import { Container } from "reactstrap";
import { useParams } from "react-router";
import { getUsersList, retrieveSurveysListByIdOrName, retrieveTaskDetails, retrieveTasksArchive } from "utils/api";
import { Spin } from "antd";
import Header from "pages/operations/taskDetails/Header";
import DataTabs from "pages/operations/taskDetails/DataTabs";
import { AUTH_USER, USER_ROLES } from "utils/constants";
import NotFoundContainer from "components/Common/NotFoundContainer";
import { useDispatch } from "react-redux";
import { getDictionary } from "store/dictionaries/actions";
import { DICTIONARY_TYPES } from "store/dictionaries/constants";

const TaskDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [task, setTask] = useState(null);
  const [isLoading, setLoader] = useState(false);
  const [agentList, setAgentList] = useState([]);
  const [isNotFound, setIsNotFound] = useState(false);
  const [questionnaire, setQuestionnaire] = useState({});
  const [feedbacks, setFeedbacks] = useState({
    current: [],
    prev: [],
  });

  const updateTask = useCallback(() => {
    retrieveTaskDetails(id)
      .then(({ data }) => {
        setTask(data.result);
        if (data?.result?.survey?.id) {
          retrieveSurveysListByIdOrName({ id: data?.result?.survey?.id }).then(res => {
            setQuestionnaire(res.data.result);
          });
        }
        if (data?.result?.category === "Intervention Call") {
          retrieveTasksArchive({
            customerId: data?.result?.customerId,
            category: data?.result?.category,
            status: "Completed",
          }).then(res => {
            const {
              result: { items },
            } = res?.data;
            setFeedbacks({
              current: data?.result?.inlineSurvey?.items || [],
              prev: items[1]?.inlineSurvey?.items || [],
            });
          });
        }
      })
      .catch(error => {
        setLoader(false);
        if (error.response?.data?.errors[0]?.code === "NOT_FOUND") {
          setIsNotFound(true);
        }
      });
  }, [id]);

  useEffect(() => {
    updateTask();

    dispatch(getDictionary(DICTIONARY_TYPES.INTERVENTION_CALL_SURVEY));
  }, []);

  useEffect(() => {
    getUsersList({
      role: [USER_ROLES.MMT, USER_ROLES.TECHNICIANS, USER_ROLES.MTSR, USER_ROLES.TSS, USER_ROLES.MDSC].join(),
      depot: AUTH_USER()?.depotName,
      pageSize: 1000,
    }).then(res => {
      setAgentList(res?.data?.result?.items);
    });
  }, []);

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <NotFoundContainer isNotFound={isNotFound}>
            <Spin spinning={isLoading}>
              {task && (
                <>
                  <Header task={task} setLoader={setLoader} agentList={agentList} updateTask={updateTask} />
                  <DataTabs task={task} questionnaire={questionnaire} feedbacks={feedbacks} />
                </>
              )}
            </Spin>
          </NotFoundContainer>
        </Container>
      </div>
    </>
  );
};

export default TaskDetails;
